export class Resource {
    public static BASE: string = "wp-content/themes/eventfive.awi.touch/";
    public static DATA: string = "wp-json/data-api/v1/data?nonce=19840730";
    public static SITE: string = "./";

    public static init(element: HTMLElement): void {
        this.DATA = element.getAttribute("data-dataurl");
        this.BASE = element.getAttribute("data-base");
        this.SITE = element.getAttribute("data-site");
    }

    public static resolve(path: string): string {
        return this.BASE + path;
    }
}